import React from 'react';
import type { Theme } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import TableCellMui, { TableCellProps } from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';

import useIconParrot from 'hooks/useIconParrot';

interface Props extends TableCellProps {
  active?: boolean;
  disabled?: boolean;
  isSorting?: boolean;
  direction?: 'asc' | 'desc';
  children: React.ReactNode;
}

const TableCell = withStyles((theme: Theme) => ({
  root: {
    padding: 12,
    paddingBottom: 0,
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.darkGrey.main,
    borderBottom: 0,
    lineHeight: 'normal',
    zIndex: 1000,
  },
}))(TableCellMui);

function TableHeadCell({
  align = 'center',
  active = false,
  disabled,
  isSorting,
  direction,
  children,
  ...others
}: Props) {
  const { IconArrowDownTable } = useIconParrot({ icon: 'arrowDownTable' });

  return (
    <TableCell align={align} {...others}>
      {isSorting && (
        <TableSortLabel IconComponent={IconArrowDownTable} active={active} direction={direction} disabled={disabled}>
          {children}
        </TableSortLabel>
      )}

      {!isSorting && children}
    </TableCell>
  );
}

export default TableHeadCell;
